import AcfFeaturesList from "@/Components/Front/Blocks/Acf/AcfFeaturesList";
import AcfImageWithContent from "@/Components/Front/Blocks/Acf/AcfImageWithContent";
import FrontOurTeamCards from "@/Components/Front/Blocks/FrontOurTeamCards";
import ServiceDescription from "@/Components/Front/Blocks/ServiceDescription";
import ServicesHero from "@/Components/Front/Blocks/ServicesHero";
import WebpImage from "@/Components/Front/Blocks/WebpImage";
import FrontSeoMetaTags from "@/Components/Front/Partials/FrontSeoMetaTags";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import resolveLocaleRoute from "@/Helpers/resolveLocaleRoute";
import FrontLayout from "@/Layouts/System/FrontLayout";
import { useTranslation } from "react-i18next";

const BtsProjects = ({ seo, agents }) => {
    const { t, i18n } = useTranslation();

    return (
        <FrontLayout breadcrumbs={[
            { title: t('breadcrumbs.services'), current: false, href: resolveLocaleRoute('front.services', null, i18n.resolvedLanguage) },
            { title: t('services.btsBreadcrumbs'), current: true },
        ]}>
            <FrontSeoMetaTags seo={seo}/>
            <section>
                <ServicesHero icon={'/storage/icons/service-form-icon.svg'} title={t('services.btsBreadcrumbs')} />
                <ServiceDescription contentKey={'services.btsEntryText'} lng={i18n.resolvedLanguage}>
                    <WebpImage
                        className='rounded-10 mt-5 w-full h-[295px] object-cover'
                        sources={[
                            {
                                width: 530,
                                path: '/storage/images/bts-size-530',
                                mime: '/jpg'
                            },
                            {
                                width: 375,
                                path: '/storage/images/bts-size-375',
                                mime: '/jpg'
                            },
                            {
                                width: 1,
                                path: '/storage/images/bts',
                                mime: 'jpg'
                            }
                        ]}
                        alt={'bts'}
                        fallback={`/storage/images/bts.jpg`}
                        seo={{
                            width: 520,
                            height: 295
                        }}
                    />
                </ServiceDescription>
            </section>

            <section>
                <Container>
                    <Row>
                        <AcfFeaturesList
                            blockSpacing="xl:mb-c120 lg:mb-20 md:mb-15 mb-10"
                            list={t('services.BtsFeaturesList', {returnObjects: true})}
                        />
                    </Row>
                </Container>
            </section>
            <section>
                <Container>
                    <Row>
                        <AcfImageWithContent
                            blockSpacing="xl:mb-c120 lg:mb-20 md:mb-15 mb-10"
                            heading={t('services.BtsAcfBlockHeading')}
                            description={t('services.BtsAcfBlockDescription')}
                            graphql={false}
                            sourcesWebp={[
                                {
                                    width: 530,
                                    path: '/storage/images/bts-projects-size-530',
                                    mime: '/jpg'
                                },
                                {
                                    width: 375,
                                    path: '/storage/images/bts-projects-size-375',
                                    mime: '/jpg'
                                },
                                {
                                    width: 1,
                                    path: '/storage/images/bts-projects',
                                    mime: 'jpg'
                                }
                            ]}
                            fallbackWebp={`/storage/images/bts-projects.jpg`}
                        />
                    </Row>
                </Container>
            </section>
            <section className="xl:mb-c120 lg:mb-25 md:mb-20 mb-15">
                <FrontOurTeamCards agents={agents}/>
            </section>
        </FrontLayout>
    )
}

export default BtsProjects;